module.exports = __webpack_public_path__ + "static/media/hotels-armenia.727a6448.jpg";